export default __webpack_public_path__ + "static/media/news-single.5b456548.jpg";